
// export default 'data:video/mp4;base64,video-focus-test';
import gif from './gif';
export default gif;



// WEBPACK FOOTER //
// ./node_modules/ally.js/src/supports/media/mp4.js